import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import icon_39 from "../assets/figma/independence.svg";
import icon_28 from "../assets/figma/transparency.svg";
import icon_227 from "../assets/figma/relationship.svg";


function Services() {
  const { t } = useTranslation();

  return (
    <main className="services-page">
<section className="services-hero">
  <div>
    <h1>{t("main.services.heroTitle")}</h1>
    <span />
  </div>
</section>

      <section className="services-offer">
        <div className="services-container">
          <h2>{t("main.services.title")}</h2>

          <div className="offer-grid">
            <article className="offer-card">
              <h3>{t("main.services.strutturazioneVeicoli")}</h3>
              <p>{t("main.services.strutturazioneVeicoliText")}</p>
            </article>

            <article className="offer-card">
              <h3>{t("main.services.gestPatrimoniale")}</h3>
              <p>{t("main.services.gestPatrimonialeText")}</p>

              <a
                href="https://rigsavecapital.com/"
                className="offer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Rigsave Capital →
              </a>
            </article>
          </div>
        </div>
      </section>

      <section className="why-rigsave">
        <div className="services-container">
          <h2>{t("main.services.whyRigsave")}</h2>

          <div className="why-grid">
            <article className="why-item">
              <img src={icon_39} alt={t("main.services.independenceTitle")} />
              <h3>{t("main.services.independenceTitle")}</h3>
              <p>{t("main.services.independenceText")}</p>
            </article>

            <div className="why-divider" />

            <article className="why-item">
              <img src={icon_28} alt={t("main.services.transparencyTitle")} />
              <h3>{t("main.services.transparencyTitle")}</h3>
              <p>{t("main.services.transparencyText")}</p>
            </article>

            <div className="why-divider" />

            <article className="why-item">
              <img
                src={icon_227}
                alt={t("main.services.directRelationshipTitle")}
              />
              <h3>{t("main.services.directRelationshipTitle")}</h3>
              <p>{t("main.services.directRelationshipText")}</p>
            </article>
          </div>

          <div className="services-button-wrapper">
            <Link to="/contact-us" className="services-contact-button">
              {t("main.services.contactUs")}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Services;